import { render, staticRenderFns } from "./SortBySelector.vue?vue&type=template&id=4863dc98"
import script from "./SortBySelector.vue?vue&type=script&lang=js"
export * from "./SortBySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports